module.exports = __webpack_public_path__ + "static/Dornsife-9b302469ad997ba6ed537aa3443d4a6b.webp";